module.exports = __webpack_public_path__ + "media/images/icons/prospect-settings-7fae387cc03b28758843508d0ee1f284.svg";